import { Details, Header, KeyInfo } from "."

export const ActivenetSearchResult = ({ camp }) => {
  return (
    <div className="activenet border-t border-secondary-dark/50 pt-4">
      <Header
        camp={camp}
        registerButtonClassName="bg-activenet-register hover:bg-activenet-register-hover"
      />
      <KeyInfo camp={camp} />
      <Details camp={camp} className="activenet-description" />
    </div>
  )
}
